import PropTypes from "prop-types";
import { useMessagingContext } from "../../../hooks/Messaging";

import ChannelsSkeleton from "../../Skeleton/ChannelsSkeleton";
import ConversationsList from "./ConversationsList";

const ConversationContainer = ({
  activeConversationId,
  conversations,
  loading,
  onAddConversation,
  onConversationSelected,
  onAddConversationWithApproval,
  onPendingConversationSelected
}) => {

  const { pendingConversations } = useMessagingContext();

  if (loading) {
    return <ChannelsSkeleton />;
  }

  const pendingItems = (pendingConversations || []).map((member) => ({
    pending: true,
    directMessageConversationId: null,
    latestMessageId: null,
    members: [member],
    unreadMessageCount: 0,
  }));


  const allConversations = [...pendingItems, ...conversations || []];

  return (
    <ConversationsList
      activeConversationId={activeConversationId}
      conversations={allConversations}
      onAddConversation={onAddConversation}
      onConversationSelected={onConversationSelected}
      onAddConversationWithApproval={onAddConversationWithApproval}
      onPendingConversationSelected={onPendingConversationSelected}
    />
  );
};

ConversationContainer.defaultProps = {
  activeConversationId: null,
  conversations: [],
  loading: false,
};

ConversationContainer.propTypes = {
  activeConversationId: PropTypes.number,
  conversations: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  onAddConversation: PropTypes.func.isRequired,
  onConversationSelected: PropTypes.func.isRequired,
};

export default ConversationContainer;
